import { Pipe, PipeTransform } from '@angular/core';
import { AuditRootActionEnum } from '@app/admin/user/model/user-history.model';

@Pipe({
  name: 'activityIcon',
})
export class ActivityIconPipe implements PipeTransform {
  transform(activity: AuditRootActionEnum): string | null {
    switch (activity) {
      case AuditRootActionEnum.Added:
        return 'green-check-mark';
      case AuditRootActionEnum.Deleted:
        return 'red-x';
      default:
        return null;
    }
  }
}
